// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/dumi@2.4.18_@babel+core@7.26.0_@swc+helpers@0.5.1_@types+node@18.19.68_@types+react@18._223210d39d9329c2d2d4e062a97e510f/node_modules/dumi/theme-default/slots/PreviewerActions/index.js';
